// TODO: Refactor to remove any types
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement, useCallback, useEffect, useState } from 'react';
import '../css/list.view.css';
import { ReactTablev6 } from '@cimpress/react-components';
import { COLUMN_DEFINITIONS } from '../constants';
import ErrorStateComponent from './ErrorState';

export interface TableConfig {
  columns: any[];
  keyField: string;
  loadingText: string;
  noDataText: string;
  paginationSummary?: (count: number) => string;
}
export interface ListViewProps<T> {
  fetchData: () => Promise<T[]>;
  updateTableData: (
    data: T[],
    navigateToDetails: (id: string) => void,
  ) => any[];
  navigateToDetails: (id: string) => void;
  tableConfig: TableConfig;
  handleSort: (
    data: T[],
    setData: (data: T[]) => void,
    id: string,
    desc: boolean,
  ) => void;
  ListViewZeroState?: ReactElement;
  CreateButton?: ReactElement;
}

function ListView<T>({
  fetchData,
  updateTableData,
  navigateToDetails,
  tableConfig,
  handleSort,
  ListViewZeroState,
  CreateButton,
}: ListViewProps<T>): ReactElement {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const fetchedData = await fetchData();
      handleSort(fetchedData, setData, COLUMN_DEFINITIONS.LATEST_UPDATE, true); // default sort
      const processedData = updateTableData(fetchedData, navigateToDetails);
      setData(processedData);
    } catch (error) {
      setError(
        error instanceof Error ? error : new Error('Failed to fetch data'),
      );
    } finally {
      setLoading(false);
    }
    // TODO : find better design to avoid bypassing lint
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigateToDetails]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // If there's an error, show the error state
  if (error) {
    return <ErrorStateComponent />;
  }

  return (
    <>
      {!loading && data.length === 0 && ListViewZeroState ? (
        ListViewZeroState
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              margin: '16px 0px',
            }}
          >
            {data.length > 0 && CreateButton && CreateButton}
          </div>
          <div className="pagination-summary">
            {tableConfig.paginationSummary
              ? tableConfig.paginationSummary(data.length)
              : `Showing ${data.length} of ${data.length}`}
          </div>
          <ReactTablev6
            columns={tableConfig.columns}
            data={data}
            condensed={false}
            loading={loading}
            loadingText={tableConfig.loadingText}
            noDataText={tableConfig.noDataText}
            keyField={tableConfig.keyField}
            showPageSizeOptions={false}
            minRows={loading ? 3 : 0}
            manual={true}
            onSortedChange={(newSorted) => {
              const { id, desc } = newSorted[0];
              handleSort(data, setData, id, desc);
            }}
          />
        </>
      )}
    </>
  );
}

export default ListView;
